let stripeJsPromise = null

// Load Stripe.js on demand, only when a Stripe checkout is actually shown, so
// its anti-fraud iframes (and their console noise) stay off every other page.
export default function loadStripeJs() {
  if (typeof window.Stripe === 'function')
    return Promise.resolve()
  if (stripeJsPromise)
    return stripeJsPromise
  stripeJsPromise = new Promise((resolve, reject) => {
    // eslint-disable-next-line no-undef
    const src = typeof STRIPE_JS_LIBRARY !== 'undefined' ? STRIPE_JS_LIBRARY : ''
    if (!src) {
      stripeJsPromise = null
      reject(new Error('Stripe.js is not configured'))
      return
    }
    const script = document.createElement('script')
    script.src = src
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => {
      stripeJsPromise = null
      reject(new Error('Stripe.js failed to load'))
    }
    document.head.appendChild(script)
  })
  return stripeJsPromise
}
